import http from '../../utils/http/local'

const getExtendSession = () => http({ url: '/sessions/refresh' })
export default getExtendSession
